import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import {
  NgbDropdownModule,
  NgbDatepickerModule,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-route-header',
  templateUrl: './route-header.component.html',
  styleUrls: ['./route-header.component.css'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    NgbDatepickerModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteHeaderComponent {
  readonly iconClass = input<string>();
  readonly dropdownText = input<string>();
  readonly dropdownOptions = input<string[]>();
  readonly displayFilterInput = input(false);
  readonly filterInputPlaceholder = input<string>();
  readonly displayModalButton = input(false);
  readonly modalButtonText = input('');
  readonly displayDateFilter = input(false);
  readonly dateFilterPlaceholder = input<string>();
  readonly displayCustomButton = input(false);
  readonly customButtonText = input('');
  readonly dropdownChangeEvent = output<string>();
  readonly filterInputChangeEvent = output<string>();
  readonly dateFilterChangeEvent = output<string>();
  readonly openModalClicked = output<boolean>();
  readonly customButtonClicked = output<boolean>();
  readonly exportExcelClicked = output<boolean>();

  filterInput = new UntypedFormControl('');
  dateFilter = new UntypedFormControl('');

  constructor() {
    this.filterInput.valueChanges.subscribe((value: string) => {
      this.filterInputChangeEvent.emit(value);
    });
    this.dateFilter.valueChanges.subscribe((value: string) => {
      this.dateFilterChangeEvent.emit(value);
    });
  }

  dropdownSelected(selection: string): void {
    this.dropdownChangeEvent.emit(selection);
  }

  openModal(): void {
    this.openModalClicked.emit(true);
  }

  onCustomButtonClick(): void {
    this.customButtonClicked.emit(true);
  }

  exportExcel(): void {
    this.exportExcelClicked.emit(true);
  }
}
